import { Line } from "./Line";

export enum CaretPlacement
{
  BEFORE,
  AFTER
}

export class Caret
{
  #line:number;
  get line(){ return this.#line; }


  #character:number;
  get character(){ return this.#character; }

  #placement:CaretPlacement;
  get placement(){ return this.#placement; }

  get characterIndex()
  {
    let offset = CaretPlacement.BEFORE === this.placement ? 0 : 1;
    return this.character + offset; 
  }

  constructor( line:number, character:number, placement:CaretPlacement )
  {
    this.#line = line;
    this.#character = character;
    this.#placement = placement;
  }

  clone()
  {
    return new Caret( this.line, this.character, this.placement );
  }

  static before( line:number, character:number )
  {
    return new Caret( line, character, CaretPlacement.BEFORE );
  } 

  static after( line:number, character:number )
  {
    return new Caret( line, character, CaretPlacement.AFTER );
  } 

  
  static equals( a:Caret, b:Caret )
  {
    if ( a.line != b.line )
    {
      return false;
    }

    if ( a.character != b.character )
    {
      return false;
    }

    if ( a.placement != b.placement )
    {
      return false;
    }
    

    return true;
    

  }
}

